import { render, staticRenderFns } from "./JobBoardStm.vue?vue&type=template&id=1b366169"
import script from "./JobBoardStm.vue?vue&type=script&lang=js"
export * from "./JobBoardStm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports